<template>
  <a-modal v-model:visible="open" :width="792" centered title="上传优质案例" :maskClosable="false">
    <a-spin
      tip="正在导入数据，请勿关闭或刷新页面"
      :spinning="importloading"
      wrapperClassName="importSpining"
    >
      <div class="importContent" :style="{ opacity: importloading ? 0 : 1 }">
        <a-steps class="stepsBox" :current="uploadCurrent">
          <a-step title="上传文件" />
          <a-step title="保存结果" />
        </a-steps>

        <div class="uploadForm" v-if="uploadCurrent === 0">
          <div class="formItem">
            <span class="formLabel">下载上传模版：</span>
            <div>
              <div @click="downloadTemplate" class="link">《优秀案例模板》.xlsx</div>
              <div class="tips">须按模板填写，使用导出的文件修改上传</div>
            </div>
          </div>

          <div class="formItem" style="margin-top: 24px">
            <span class="formLabel" style="padding-top: 6px">上传数据：</span>
            <a-upload
              v-model:file-list="uploadFileList"
              name="file"
              :action="action"
              :showUploadList="Boolean(uploadFileList.length)"
              :headers="{ [TokenKey]: getToken() }"
              @change="handleUpload"
              :before-upload="beforeUpload"
              accept=".xlsx"
            >
              <div style="width: 200px">
                <a-button class="uploadBtn">
                  <upload-outlined></upload-outlined>
                  {{ uploadFileList.length ? '重新上传' : '上传文件' }}
                </a-button>
              </div>
            </a-upload>
          </div>

          <div v-if="uploadError.length" class="error">
            {{ uploadError }}
          </div>
        </div>
        <div class="uploadForm" v-if="uploadCurrent === 1">
          <div class="result">
            <auth-img :src="saveSuccess ? SaveDone : SaveFail" alt="" />
            <div class="tips">{{ saveSuccess ? '保存成功' : '保存失败' }}</div>
          </div>
        </div>
      </div>
    </a-spin>
    <template #footer>
      <a-button v-if="!uploadCurrent" :loading="importloading" @click="open = false">取消</a-button>
      <a-button
        v-if="!uploadCurrent"
        :loading="importloading"
        type="primary"
        @click="handleSaveCase"
        :disabled="Boolean(uploadError.length) || !uploadFileList.length"
      >
        保存
      </a-button>
      <a-button v-if="uploadCurrent" @click="closeEffect">关闭</a-button>
    </template>
  </a-modal>
</template>

<script setup>
import axios from 'axios'
import { defineExpose, ref, defineEmits } from 'vue'
import { UploadOutlined } from '@ant-design/icons-vue'
import { getToken, TokenKey } from '@/utils/auth'
import { message } from 'ant-design-vue'
import SaveDone from '@/assets/img/saveDone.png'
import SaveFail from '@/assets/img/saveFail.png'

const open = ref(false)
const showConfirm = () => {
  uploadCurrent.value = 0
  uploadError.value = ''
  importloading.value = false
  uploadFileList.value = []
  open.value = true
}

const action =
  process.env.VUE_APP_BASE_API + '/health-doctor-assistant/workOrderExcellentCase/uploadAndCheck'
const importloading = ref(false)
const uploadCurrent = ref(0)
const uploadFileList = ref([])

const downloadTemplate = () => {
  const hide = message.loading('模版下载中...', 0)
  return axios({
    url:
      process.env.VUE_APP_BASE_API +
      '/health-doctor-assistant/workOrderExcellentCase/exportTemplate',
    method: 'post',
    responseType: 'blob',
    headers: {
      [TokenKey]: getToken()
    }
  }).then(res => {
    hide()
    if (res.data.type === 'application/json') {
      message.error('下载失败')
    } else {
      const blob = new Blob([res.data])
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, '优秀案例模版.xlsx')
      } else {
        const link = document.createElement('a')
        const evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = URL.createObjectURL(blob)
        link.download = '优秀案例模版.xlsx'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      }
    }
  })
}

const uploadError = ref('')
const beforeUpload = () => {
  uploadError.value = ''
  uploadFileList.value = []
  importloading.value = true
}
const handleUpload = fileObj => {
  const { file, fileList } = fileObj
  const [uploadFile] = fileList
  const uploadRes = uploadFile.response?.data
  if (Object.keys(uploadRes || {}).length) {
    if (uploadRes.success) {
      uploadError.value = ''
      uploadFileList.value = [file]
      message.success('上传成功！')
    } else if (!uploadRes.success) {
      uploadFileList.value = []
      uploadError.value = uploadRes.msgContent
    }
    importloading.value = false
  }
}

const emit = defineEmits(['refresh'])
const saveSuccess = ref(true)
const handleSaveCase = () => {
  importloading.value = true
  const [curFile] = uploadFileList.value
  const formData = new FormData()
  formData.append('file', curFile.originFileObj)
  axios({
    url: process.env.VUE_APP_BASE_API + '/health-doctor-assistant/workOrderExcellentCase/save',
    method: 'post',
    data: formData,
    headers: {
      [TokenKey]: getToken(),
      'content-type': 'multipart/form-data'
    }
  })
    .then(res => {
      saveSuccess.value = res.data.success
    })
    .finally(res => {
      uploadCurrent.value = 1
      importloading.value = false
    })
}

const closeEffect = () => {
  open.value = false
  emit('refresh')
}

defineExpose({
  showConfirm
})
</script>

<style lang="scss" scoped>
.importSpining {
  background-color: #fff;
}
.importContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 300px;
  .stepsBox {
    width: 296px;
    margin-bottom: 48px;
  }

  .uploadForm {
    width: 60%;
    padding-bottom: 38px;
    .formItem {
      display: flex;
      align-items: flex-start;
      .link {
        cursor: pointer;
        color: #1890ff;
        margin-bottom: 8px;
      }

      .tips {
        font-weight: 400;
        font-size: 12px;
        color: #8c8c8c;
      }

      .uploadBtn {
        border: 1px solid #1890ff;
        border-radius: 4px;
        color: #1890ff;
      }
    }
    .formLabel {
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      margin-right: 8px;
      min-width: 98px;
      text-align: right;
    }
    .error {
      width: 454px;
      background: #fff5f5;
      padding: 10px 12px;
      margin-top: 14px;
      color: #ff4848;
    }

    .result {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 48px;
        height: 48px;
        margin-bottom: 16px;
        margin-top: 30px;
      }

      .tips {
        font-size: 16px;
        color: #262626;
      }
    }
  }
}
</style>
